import { Button, LoadIndicator, ScrollView, Toolbar, Tooltip } from 'devextreme-react';
import { useCallback, useEffect, useRef, useState } from 'react';
import Popup, { ToolbarItem } from 'devextreme-react/popup';
import { useAppDispatch, useAppSelector } from '../../../../../contexts/hooks';
import { useScreenSize } from '../../../../../utils/media-query';
import { showModalImages } from '../../../../../contexts/slices/orders';
import 'devextreme-react/text-area';
import { Item } from 'devextreme-react/toolbar';
import { deleteIcon, resButtonsPin, resGridStatus1, resGridStatus2, resGridStatus3, resGridStatus4, resGridStatus5 } from '../../../../../images/icons';
import { ResultEstadoResult } from '../../../../../types/types.orders';
import { UseApiResults } from '../../../../../api/api.results';
import { newToast } from '../../../..';

export const ModalResultImages = () => {
  const dataModal = useAppSelector((x) => x.globalOrders.CurrentOrder.ModalResultImage);
  const { putResultImage, getResultImage } = UseApiResults();
  const Prm_ResC = useAppSelector((x) => x.userInfo.Permissions?.Prm_ResC) || false;
  const dispatch = useAppDispatch();
  const { isMedium, isSmall, isXSmall } = useScreenSize();
  const [loading, setLoading] = useState<boolean>(false);
  const [imageSource, setImageSource] = useState<string>('');

  const refFile = useRef<HTMLInputElement>(null);
  useEffect(() => {
    if (dataModal && dataModal.Visible && dataModal?.Res_Estado >= ResultEstadoResult.ConResultado) {
      setLoading(true);
      getResultImage(dataModal.Res_Id)
        .then((res) => {
          const binaryString = window.atob(res.Rim_Imagen);
          const bytes = new Uint8Array(binaryString.length);
          for (let i = 0; i < binaryString.length; i++) {
            bytes[i] = binaryString.charCodeAt(i);
          }
          const blob = new Blob([bytes], { type: 'image/*' }); // Cambia el tipo de imagen según corresponda
          setImageSource(URL.createObjectURL(blob));
        })
        .finally(() => {
          setLoading(false);
        });
    }
  }, [dataModal]);

  const getIconStatus = () => {
    switch (dataModal?.Res_Estado) {
      case ResultEstadoResult.SinResultado:
      default:
        return resGridStatus1;
      case ResultEstadoResult.ConResultado:
        return resGridStatus2;
      case ResultEstadoResult.Validado:
        return resGridStatus3;
      case ResultEstadoResult.Impreso:
        return resGridStatus4;
      case ResultEstadoResult.OtrasFuentes:
        return resGridStatus5;
      case ResultEstadoResult.ValidadoBlanco:
        return resButtonsPin;
    }
  };

  const getTextStatus = () => {
    switch (dataModal?.Res_Estado) {
      case ResultEstadoResult.SinResultado:
      default:
        return 'SIN RESULTADO';
      case ResultEstadoResult.ConResultado:
        return 'CON RESULTADO';
      case ResultEstadoResult.Validado:
        return 'VALIDADO';
      case ResultEstadoResult.Impreso:
        return 'IMPRESO';
      case ResultEstadoResult.OtrasFuentes:
        return 'OTRAS FUENTES';
      case ResultEstadoResult.ValidadoBlanco:
        return 'FIJADO EN BLANCO';
    }
  };

  const handleUploadStarted = useCallback(
    (e) => {
      if (e.target.files.length === 0) {
        return;
      }
      if (!dataModal?.Res_Id) {
        newToast('WARNING', 'No se ha podido identificar el analito a actualizar', 4);
        return;
      }
      const myFile = e.target.files[0];
      const allowedExtensions = /(\.jpg|\.jpeg|\.png)$/i;
      if (!allowedExtensions.exec(myFile.name)) {
        newToast('ERROR', 'Formato de archivo no permitido', 5);
        return;
      }

      setLoading(true);
      const fileReader = new FileReader();
      fileReader.onload = () => {
        const result = fileReader.result;
        if (typeof result === 'string') {
          const base64String = result.split(';base64,').pop();
          putResultImage({ keys: [dataModal?.Res_Id], Result: base64String })
            .then((res) => {
              if (res) {
                setImageSource(result);
              }
            })
            .finally(() => {
              setLoading(false);
            });
        } else if (result instanceof ArrayBuffer) {
          setImageSource(new TextDecoder().decode(result));
        }
      };
      fileReader.readAsDataURL(myFile);
    },
    [dataModal]
  );

  const handleDeleteImage = useCallback(() => {
    if (dataModal && dataModal?.Res_Estado >= ResultEstadoResult.Validado) {
      newToast('WARNING', 'No se puede eliminar el resultado validado.', 4);
      return;
    }
    setLoading(true);
    putResultImage({ keys: [dataModal?.Res_Id] })
      .then((res) => {
        if (res) {
          setImageSource('');
        }
      })
      .finally(() => {
        setLoading(false);
      });
  }, [dataModal]);

  const handleClose = useCallback(() => {
    dispatch(showModalImages({ Visible: false, An_Id: -1, An_Nombre: '', An_Plantilla: '', Res_Estado: ResultEstadoResult.Validado, Res_Id: -1, Res_Resultado: '', Update: true, Pc_Id: -1 }));
    setImageSource('');
  }, []);

  return (
    <Popup visible={dataModal?.Visible || false} onHidden={handleClose} fullScreen={isMedium || isSmall || isXSmall} width={400} height={'auto'} title={dataModal?.An_Nombre || ''}>
      <ScrollView>
        <Toolbar>
          <Item widget='dxButton' locateInMenu='auto' location='before'>
            <Button icon={getIconStatus()} text={getTextStatus()} stylingMode='text' />
          </Item>
          <Item location='after' locateInMenu='auto' showText='inMenu' widget='dxButton'>
            <Button
              id='LoadResultImg'
              icon='add'
              text='Cargar imagen'
              disabled={(dataModal && dataModal?.Res_Estado >= ResultEstadoResult.Validado) || !Prm_ResC || imageSource ? true : false}
              onClick={() => {
                refFile.current?.click();
              }}
              stylingMode='text'
            />
            <Tooltip target={'#LoadResultImg'} showEvent='mouseenter' hideEvent='mouseleave' position={'top'}>
              Cargar nueva imagen.
            </Tooltip>
          </Item>
          <Item location='after' locateInMenu='auto' showText='inMenu' widget='dxButton'>
            <Button id='RemoveResultImg' icon={deleteIcon} text='eliminar imagen' disabled={!imageSource} onClick={handleDeleteImage} stylingMode='text' />
            <Tooltip target={'#RemoveResultImg'} showEvent='mouseenter' hideEvent='mouseleave' position={'top'}>
              Eliminar imagen del resultado.
            </Tooltip>
          </Item>
        </Toolbar>

        <div className='widget-container flex-box'>
          <input type='file' accept='.jpg,.jpeg,.png' ref={refFile} hidden={true} onChange={handleUploadStarted} />
          <div id='dropzone-external' className={`flex-box dx-theme-accent-as-border-color dropzone-active`}>
            <LoadIndicator visible={loading} />
            {imageSource && <img src={imageSource} alt='' id='dropzone-image' />}
          </div>
        </div>
      </ScrollView>
      <ToolbarItem widget='dxButton' toolbar='bottom' location='after' options={{ text: 'CERRAR', type: 'normal', onClick: handleClose }} />
    </Popup>
  );
};
